import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Form from "@sm/core/Form";
import { DATA_TYPES } from "@modules/data/ManualInput";

class OtcWithdrawalByRequestComponent extends Component {
  componentDidMount() {
    const { controls, getOptionsFromState } = this.props;
    if (controls) {
      this.setState({
        getOptionsFromParentState: getOptionsFromState,
      });
    }
  };

  onChangeFilter = () => {
    const { controls } = this.props;

    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);

    if (isFormValid) {
      const { merchant, currency, id } = controls;
      const url = `v1/otc/balances/withdrawal?clientIds=${ merchant }&currency=${ currency }${ id ? `&id=${id}` : '' }`;

      crudActions.get(url)
        .then((response) => {
          if (response.length) {
            const newState = this.populateOtcWithdrawalByRequestForm(response, controls);
            Object.assign(newState, {
              showSecondPanel: true,
              loadingDataInput: false,
              lockButton: false,
            });
            this.updateState(newState);
          } else {
            this.errorUpdate("No active withdrawal requests found. All existing requests are already approved or cancelled.");
          }
        })
        .catch(err => {
          this.errorUpdate(err?.message);
        });
    }
  };

  populateOtcWithdrawalByRequestForm = (response, controls) => {
    const OTC_WITHDRAWAL_BY_REQUEST = [];
    const stateForUpdate = {};

    response.forEach((elem, id) => OTC_WITHDRAWAL_BY_REQUEST.push(this.getOtcWithdrawalByRequestFields(id)));
    const otcWithdrawalByRequestForm = [];
    response.forEach(topUp => {
      otcWithdrawalByRequestForm.push(this.getWithdrawalByRequestForm(topUp, controls));
    });
    this.updateField(DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST, OTC_WITHDRAWAL_BY_REQUEST);
    Object.assign(stateForUpdate, {
      otcWithdrawalByRequestForm
    });
    return stateForUpdate;
  };

  getWithdrawalByRequestForm = (data, controls) => {
    return new Form(
      {
        id: data.id,
        currency: controls.currency || "",
        merchant: data.merchantId || "",
        merchantName: data.merchantName || '',
        date: data.date || "date",
        balance: data.balance,
        wallet: data.walletName,
        withdrawAmount: data.amount.toString(),
        status: data.status,
        allowedToChange: data.allowedToChange,
        confirmationLink: data.validationLink || ''
      },
      [
        {
          name: "currency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "balance",
          type: "isNumber",
          rules: {
            min: 1,
            required: true,
          },
        },
        {
          name: "wallet",
          type: "isString",
          rules: {
            min: 1,
            required: true,
          },
        },
        {
          name: "withdrawAmount",
          type: "isString",
          rules: {
            min: 1,
            required: true,
          },
        },
        {
          name: "status",
          type: "isString",
          rules: {
            min: 1,
            required: true,
          },
        },
        {
          name: "confirmationLink",
          type: "isString",
          rules: {
            min: 1,
            required: true,
          },
        }
      ]
    );
  };

  getOtcWithdrawalByRequestFields = (id) => {
    return [
      {
        name: "merchantName",
        label: "Merchant",
        disabled: true,
        fieldType: "input",
        flexGrow: 3,
      }, {
        name: "date",
        label: "Date",
        disabled: true,
        fieldType: "input",
        flexGrow: 4,
      }, {
        name: "balance",
        label: "Balance",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 4,
        rightAlign: true,
      }, {
        name: "wallet",
        label: "Wallet",
        disabled: true,
        fieldType: "input",
        flexGrow: 5,
      }, {
        name: "withdrawAmount",
        label: "Withdraw Amount",
        fieldType: "isString",
        flexGrow: 4,
        disabled: true,
        rightAlign: true,
      }, {
        name: "confirmationLink",
        label: "Confirmation Link",
        disabled: false,
        fieldType: "input",
        flexGrow: 5,
      }, {
        fieldType: "button",
        className: "btn-secondary",
        buttonLabel: "Cancel",
        buttonAction: () => this.cancelOtcWithdrawalRequest(id)
      }, {
        fieldType: "button",
        buttonLabel: "Approve",
        buttonAction: () => this.approveOtcWithdrawalRequest(id)
      }
    ];
  };

  decreaseForm = (form) => {
    const OTC_WITHDRAWAL_BY_REQUEST = [];
    form.forEach((elem, index) => OTC_WITHDRAWAL_BY_REQUEST.push(this.getOtcWithdrawalByRequestFields(index)));
    this.updateField(DATA_TYPES.OTC_WITHDRAWAL_BY_REQUEST, OTC_WITHDRAWAL_BY_REQUEST);
    this.updateState({
      otcWithdrawalByRequestForm: form
    });
  };

  approveOtcWithdrawalRequest = (id) => {
    const { form } = this.props;
    const formRow = form[id];
    const isFormValid = formRow.isFormValid();

    this.saveValidationUpdate(form, isFormValid, isFormValid);

    if (isFormValid) {
      crudActions.put(`v1/otc/balances/withdrawal/approve/${ formRow.id }?validationLink=${formRow.confirmationLink}`)
        .then(() => {
          form.splice(id, 1);
          this.afterSuccessSave("Withdrawal request approved.", form.length > 0);
          this.decreaseForm(form, id);
        }).catch((err) => {
          this.errorUpdate(err?.message);
        });
    }
  };

  cancelOtcWithdrawalRequest = (id) => {
    const { form } = this.props;
    const formRow = form[id];
    crudActions.put(`v1/otc/balances/withdrawal/reject/${ formRow.id }`)
      .then(() => {
        form.splice(id, 1);
        this.afterSuccessSave("Withdrawal request cancelled.", form.length > 0);
        this.decreaseForm(form, id);
      }).catch((err) => {
        this.errorUpdate(err?.message);
      });
  };

  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };
  
  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = (message, dataPresent) => {
    this.props.updateStateAfterSuccessSave(message, dataPresent);
  };

  errorUpdate = (message) => {
    this.props.showErrorAlert(message);
  };

  render() {
    return <></>;
  };
}

export default OtcWithdrawalByRequestComponent;